import { mergeAttributes, Node } from '@tiptap/core'

export const ConditionsAddressedBlockNode = Node.create({
  name: 'conditions-addressed-block',
  group: 'block',
  atom: true,
  parseHTML() {
    return [{ tag: `div[data-type="${this.name}"]` }]
  },
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes({ 'data-type': this.name }, HTMLAttributes)]
  },
})
